import * as HLF from "html-living-framework";
import { texture } from "../core/AssetHelpers";
import {BaseButton, HoverableButton, TextureButton} from "../core/Button";
import { Container } from "../core/Container";
import {Callback, Mix} from "../core/Reflection";
import { ISignal, Signal } from "../core/Signal";
import { Sprite } from "../core/Sprite";
import {TransformBackup} from "../core/TransformBackup";
import * as PlanterGameModel from "../data/PlanterGameModel";
import {TrashType} from "../data/TrashType";
import { ColorRampFilter } from "../filters/ColorRampFilter";
import { OutlineFilter } from "../filters/OutlineFilter";
import { Button } from "./Button";
import { Draggable, IDraggable, InteractionEvent, InteractionListener } from "./Draggable";
import { SplashPlayButton } from "./SplashPlayButton";

export class CustomizeOptionButton extends Mix(Button, Draggable) implements IDraggable {
    public index: number;
    public readonly bg = this.addChild(new Sprite());
    public readonly bgOn = this.addChild(new Sprite());
    public readonly icon = this.addChild(new Sprite());
    public readonly check = this.addChild(new Sprite());
    public tab: PlanterGameModel.Tabs;
    public readonly onStartDrag: ISignal<InteractionListener> = Signal<InteractionListener>();
    public readonly onQuickClick: ISignal<InteractionListener> = Signal<InteractionListener>();
    protected _subscriptions: any[] = [];

    protected colorRampFilter?: ColorRampFilter;
    protected outlineFilter?: OutlineFilter;

    constructor(pTab: PlanterGameModel.Tabs, pIndex: number) {
        super();
        this.tab = pTab;
        this.index = pIndex;
        this.toggle = true;
        this.clickSfx = "buttonclick";

        this.onStartDrag.add((e: InteractionEvent, context?: any) => {
            this.onPointerUp(e!);
            this.onClick(this, e!);
        });

        this.onChange.add((b, val) => {
            this.check.visible = val;
            this.bgOn.visible = val;
            PubSub.publishSync("button clicked", this);
            if (val) {
                PubSub.publishSync("option selected", this);
                // prevent deselection
                switch (pTab) {
                    case PlanterGameModel.Tabs.Shape:
                    case PlanterGameModel.Tabs.Colour:
                        this.interactive = false;
                        break;
                }
            }
            else {
                PubSub.publishSync("option cleared", this);
                this.interactive = true;
            }
        });

        this.bg.visible = true;
        this.check.visible = false;
        this.bgOn.visible = false;

        this._subscriptions.push(PubSub.subscribe("button clicked", this.onButtonClicked.bind(this)));

        let shapeName: string;
        let colourName: string;
        let patternName: string;
        let stickerName: string;

        switch (pTab) {
            case PlanterGameModel.Tabs.Shape:
                shapeName = Object.values(PlanterGameModel.PlanterShape)[pIndex];
                this.icon.setLayoutTexture(shapeName, 0.5, 0.5);
                if (shapeName === PlanterGameModel.GameState.shape) {
                    // this.selected = true;
                }
                break;
            case PlanterGameModel.Tabs.Colour:
                colourName = Object.values(PlanterGameModel.PlanterColour)[pIndex];
                this.icon.setLayoutTexture(colourName, 0.5, 0.5);
                this.bg.visible = false;
                this.outlineFilter = new OutlineFilter(2, 0xe9e9e9);
                this.icon.filters = [this.outlineFilter];
                if (colourName === PlanterGameModel.GameState.colour) {
                    // this.selected = true;
                }
                break;
            case PlanterGameModel.Tabs.Pattern:
                patternName = Object.values(PlanterGameModel.PlanterPattern)[pIndex];
                colourName = PlanterGameModel.GameState.colour;
                this.icon.setLayoutTexture(patternName, 0.5, 0.5);
                this.bg.visible = false;
                this.colorRampFilter = new ColorRampFilter(texture("planterparty-" + colourName + "-gradientmap")!);
                this.outlineFilter = new OutlineFilter(2, 0xe9e9e9);
                this.icon.filters = [this.colorRampFilter, this.outlineFilter];
                if (patternName === PlanterGameModel.GameState.pattern) {
                    // this.selected = true;
                }
                break;
            case PlanterGameModel.Tabs.Stickers:
                stickerName = Object.values(PlanterGameModel.PlanterSticker)[pIndex];
                this.icon.setLayoutTexture(stickerName, 0.5, 0.5);
                if (stickerName === PlanterGameModel.GameState.sticker) {
                    // this.selected = true;
                }
                break;
        }

        this.check.alpha = 0; // temp?
        this.onChange.call(this, this, this.selected);
        this.name = this.icon.name;
    }

    public onLayout() {
        if (this.tab === PlanterGameModel.Tabs.Colour || this.tab === PlanterGameModel.Tabs.Pattern) {
            this.icon.width = 109;
            this.icon.height = 109;
        }
    }

    public destroy() {
        super.destroy();
        for (const subscription of this._subscriptions) {
            PubSub.unsubscribe(subscription);
        }
    }

    protected onButtonClicked(pTopic: string, pData: CustomizeOptionButton) {
        if (pData === this) {
            //
        }
        else if (pData.tab === this.tab && pData.selected && this.selected) {
            // deselect this button if another one in the same tab was clicked
            this.selected = false;
            this.onChange.call(this, this, false);
        }
        else if (this.tab === PlanterGameModel.Tabs.Pattern && pData.tab === PlanterGameModel.Tabs.Colour) {
            this.colorRampFilter!.uniforms.uRamp = texture("planterparty-" + Object.values(PlanterGameModel.PlanterColour)[pData.index] + "-gradientmap");
        }
    }
}
